const portfolio = {
  namespaced: true,
  state: () => ({
    project: {},
    projects: [
      {
        name: "FastShop DZ – Leading Algerian Online Store",
        overview:
          "Developed a robust e-commerce website for FastShop, one of Algeria's most popular online stores. The platform supports thousands of products, secure payments, and a seamless shopping experience tailored for Algerian customers.",
        image: [
          {
            src: "/assets/images/portfolio/fastshop-1.png",
            alt: "FastShop DZ Storefront",
          },
          {
            src: "/assets/images/portfolio/fastshop-2.png",
            alt: "FastShop DZ Product Page",
          },
        ],
        slug: "fastshop-dz",
        tech: ["Laravel", "Vue.js", "MySQL"],
        intro:
          "A scalable and feature-rich e-commerce solution built for FastShop DZ, enabling efficient product management, order processing, and customer engagement.",
        client: "FastShop DZ",
        live_link: "https://fastshop.store/",
        github_link: "",
        features: [
          "Advanced product catalog with filtering and search",
          "Secure checkout and payment integration",
          "Order tracking and management for customers",
          "Admin dashboard for inventory and sales analytics",
          "Mobile-responsive design for optimal user experience",
          "Support for local delivery and payment methods",
        ],
        service: "Full Stack Development",
      },
      {
        name: "Zeros DZ Shop – Custom PC Hardware E-commerce Website",
        overview:
          "A complete e-commerce platform built for a local Algerian PC parts store. The site allows customers to browse components, build compatible PCs, and order directly with a cash-on-delivery system. Admins manage inventory, categories, and compatibility via a custom dashboard.",
        image: [
          {
            src: "/assets/images/portfolio/pc-shop-1.png",
            alt: "PC Shop Storefront",
          },
          {
            src: "/assets/images/portfolio/pc-shop-2.png",
            alt: "PC Shop Admin Panel",
          },
        ],
        slug: "pc-hardware-shop",
        tech: ["Vue.js", "Laravel", "MySQL"],
        intro:
          "A full-stack e-commerce solution tailored for a PC hardware store, featuring real-time part compatibility logic, cart system, and admin product control — all with a clean API architecture.",
        client: "Client Project",
        live_link: "https://zerostech.shop/",
        github_link: "", // optional
        features: [
          "Build My PC: real-time compatibility validation",
          "Product management with multi-category and attribute system",
          "Dynamic cart and checkout with Cash on Delivery",
          "Admin dashboard with image uploads, filters, and stock control",
          "Public API for seamless front-end integration",
        ],
        service: "Full Stack Development",
      },
      {
        name: "Tjara – Multi-Vendor Marketplace Platform",
        overview:
          "Tjara is a powerful and scalable multi-seller e-commerce platform that allows multiple vendors to sell their products through a centralized marketplace. Inspired by platforms like Amazon and Souq, Tjara provides vendors with independent dashboards while offering customers a seamless shopping experience.",
        image: [
          {
            src: "/assets/images/portfolio/tjara-2.png",
            alt: "Tjara Marketplace Dashboard",
          },
          {
            src: "/assets/images/portfolio/tjara-1.png",
            alt: "Tjara Marketplace Interface",
          },
        ],
        slug: "tjara-marketplace",
        tech: ["React.js", "Laravel", "MySQL"],
        intro:
          "A comprehensive multi-vendor marketplace platform that enables entrepreneurs to build their own online store with multiple sellers, similar to Amazon and Souq.",
        client: "Tjara",
        live_link: "https://tjara.com/",
        github_link: "",
        features: [
          "Vendor Registration & Dashboard for sellers to manage products, orders, and earnings",
          "Product Management with descriptions, pricing, and stock control",
          "Multi-Cart System allowing customers to buy from multiple sellers in a single checkout",
          "Order Management with real-time status updates for vendors and customers",
          "Commission System for admins to define rates and calculate platform earnings",
          "Secure Payments with payment gateway integration",
          "Admin Panel to manage users, products, vendors, commissions, and settings",
          "Mobile Responsive design with clean, modern UI/UX for all devices",
        ],
        service: "Full Stack Development",
      },
      {
        name: "Store Bladi - Algerian E-commerce Platform",
        overview:
          "Store Bladi is a comprehensive e-commerce platform designed specifically for the Algerian market, inspired by Shopify but tailored to local needs. The platform enables Algerian entrepreneurs to easily set up online stores, manage inventory, and reach customers across the country with features optimized for local payment methods and delivery services.",
        image: [
          {
            src: "/assets/images/portfolio/store-bladi-2.png",
            alt: "Store Bladi Dashboard",
          },
          {
            src: "/assets/images/portfolio/store-bladi-1.png",
            alt: "Store Bladi Storefront",
          },
        ],
        slug: "store-bladi",
        tech: ["React.js", "Tailwind CSS"],
        intro:
          "A localized e-commerce solution for Algerian entrepreneurs, providing an easy-to-use platform to create and manage online stores with features tailored to the Algerian market.",
        client: "Hichem Technology",
        live_link: "https://yourdrip.sou9i.pro/67cf8ff13e72e7d0fc3fc07d",
        github_link: "https://github.com/zakareiaa/amidoShop-storefront",
        features: [
          "One-click store creation with customizable themes",
          "Product management with multiple categories",
          "Mobile-responsive design",
          "Analytics dashboard with sales reports",
        ],
        service: "Full Stack Development",
      },
      {
        name: "Mieyar Admin Panel",
        overview:
          "Developed a comprehensive admin panel for Mieyar, featuring a modern dashboard interface with real-time analytics, user management, and content management capabilities. The panel provides administrators with powerful tools to manage the platform efficiently.",
        image: [
          {
            src: "/assets/images/portfolio/mieyar-admin2.png",
            alt: "Mieyar Admin Panel Dashboard",
          },
          {
            src: "/assets/images/portfolio/mieyar-admin1.png",
            alt: "Mieyar Admin Panel Interface",
          },
        ],
        slug: "mieyar-admin-panel",
        tech: ["Vue.js", "Tailwind CSS", "Laravel"],
        intro:
          "A powerful and intuitive admin panel built for Mieyar to streamline business operations and enhance management capabilities.",
        client: "Mieyar",
        live_link: "https://devadmin.mieyar.ae/login",
        github_link: "",
        features: [
          "Real-time dashboard with key metrics",
          "User management system",
          "Content management tools",
          "Role-based access control",
          "Reporting and data visualization",
          "Secure authentication",
          "Responsive design",
          "API integration",
        ],
        service: "Full Stack Development",
      },

      {
        name: "Mieyar Landing Page",
        overview:
          "Designed and developed a high-converting landing page for Mieyar, focusing on clean aesthetics, fast performance, and SEO optimization.",
        image: [
          {
            src: "/assets/images/portfolio/mieyar2.png",
            alt: "Mieyar Landing Page",
          },
          {
            src: "/assets/images/portfolio/mieyar.png",
            alt: "Mieyar Landing Page",
          },
        ],
        slug: "mieyar-landing-page",
        tech: ["Vue.js", "Tailwind CSS", "SEO"],
        intro:
          "A modern and professional landing page built for Mieyar to improve user engagement and lead generation.",
        client: "Mieyar",
        live_link: "https://www.mieyar.ae/",
        github_link: "",
        features: [
          "Fast-loading, lightweight front-end.",
          "Optimized for SEO and mobile responsiveness.",
          "Clear call-to-actions to increase conversions.",
          "Smooth animations and interactive UI elements.",
          "Easily customizable and scalable.",
        ],
        service: "Front-End Development",
      },

      {
        name: "Spotter Map Mobile Application",
        overview:
          "Spotter Map is an advanced location-based platform that helps users discover businesses and services nearby while providing business owners with tools to enhance their visibility. It features real-time interactive maps, business profiles, and smart search functionality for seamless discovery and engagement.",
        image: [
          {
            src: "/assets/images/portfolio/spotter2.png",
            alt: "Spotter Map UI Screenshot 1",
          },
          {
            src: "/assets/images/portfolio/spotter1.png",
            alt: "Spotter Map UI Screenshot 2",
          },
        ],
        slug: "spotter-map",
        tech: ["Vue.js", "Laravel", "Ionic"],
        intro:
          "Spotter Map is a smart discovery platform that connects users with local businesses through an intuitive, real-time map system. The platform is designed to help users easily find services while enabling businesses to showcase their offerings, manage profiles, and engage with potential customers.",
        client: "Spotter",
        live_link:
          "https://play.google.com/store/apps/details?id=com.originova.spotter.map",
        github_link: "",
        features: [
          "Real-time interactive map for discovering businesses nearby.",
          "Search businesses by category, ratings, and location filters.",
          "View business details, including contact info, reviews, and working hours.",
          "Step-by-step navigation to selected businesses.",
          "Business owners can create and manage profiles to attract more customers.",
          "User engagement features such as reviews, ratings, and inquiries.",
          "Responsive and mobile-friendly design with cross-platform compatibility.",
          "Optimized performance for smooth and fast loading times.",
        ],
        service: "Frontend Development",
      },

      {
        name: "Blogging Platform",
        overview:
          "The Blog Platform is a project I developed to create an easy-to-use blogging system where users can create, manage, and share posts. This platform includes features such as content management, user profiles, and a clean, modern UI. I built it using Laravel for the backend and MySQL for data management, allowing me to demonstrate my skills in Backend development, database management, and system design. It is designed to be scalable and user-friendly.",
        image: [
          {
            src: "/assets/images/portfolio/blog-admin.png",
            alt: "Project Screenshot 1",
          },
          {
            src: "/assets/images/portfolio/blog.png",
            alt: "Project Screenshot 2",
          },
        ],
        slug: "blog-platform",
        tech: ["Laravel", "Livewire", "MySQL"],
        intro:
          "This Blog Platform is a web application that allows users to create, read, update, and delete blog posts. It features user authentication, a rich text editor, and a clean, responsive design. The platform is built using HTML, CSS, JavaScript, Bootstrap, PHP (Laravel), and MySQL.",
        client: "Personal Project",
        live_link: "",
        github_link: "",
        features: [
          "Edit profile details (name, bio, avatar).",
          "Change passwords and account deletion option.",
          "Integration with social media (Twitter, Facebook, Instagram).",
          "Filter content (posts, users) by categories or tags.",
          "Pagination on post and user pages for easier navigation.",
          "View user growth and post performance metrics.",
          "Role-based access control (RBAC) and multi-role permissions.",
          "Track user actions with audit logs.",
          "Filter posts by status and filter users by roles, activity, etc.",
          "Admin can manage social media integrations.",
        ],
        service: "Full Stack Development",
      },

      {
        name: "Qwikly Website",
        overview:
          "Designed and developed a clean, functional WordPress site for a client. The site features a modern, responsive layout, SEO optimization, and easy content management to enhance user experience.",
        image: [
          {
            src: "/assets/images/portfolio/qwikly2.png",
            alt: "Qwikly Website Homepage",
          },
          {
            src: "/assets/images/portfolio/qwikly1.png",
            alt: "Qwikly Website Homepage",
          },
        ],
        slug: "qwikly-website",
        tech: ["WordPress", "Elementor", "SEO"],
        intro:
          "A professional WordPress website built for a client, ensuring an optimized, user-friendly experience with seamless navigation and responsiveness.",
        client: "Qwikly",
        live_link: "https://qwikly.io/",
        github_link: "",
        features: [
          "Custom WordPress theme with Elementor integration.",
          "SEO-optimized content and structure.",
          "Fully responsive design across all devices.",
          "Fast-loading pages and secure performance.",
          "Easy-to-update content for the client.",
        ],
        service: "WordPress Development",
      },

      {
        name: "Restaurant Management System",
        overview:
          "Developed an interactive system for restaurant operations, focusing on user-friendly interfaces and efficient functionality. It helps restaurants manage reservations, orders, and payments smoothly.",
        image: [
          {
            src: "/assets/images/portfolio/qwiklyorder2.png",
            alt: "Restaurant Management Dashboard",
          },
          {
            src: "/assets/images/portfolio/qwiklyorder1.png",
            alt: "Restaurant Management Dashboard",
          },
        ],
        slug: "restaurant-management-system",
        tech: ["Laravel", "Vue.js", "Tailwind CSS"],
        intro:
          "A feature-rich platform designed for restaurant operations, offering seamless order management, table reservations, and payment processing.",
        client: "Qwikly",
        live_link:
          "http://figma.com/proto/iirP6Wo7yu0cI75UEMCaID/QWIKLY-ORDER?t=BbMG84cNWXmeuMIg-0&scaling=contain&content-scaling=fixed&page-id=0%3A1&node-id=132-3798&starting-point-node-id=132%3A3798",
        github_link: "",
        features: [
          "Online table reservation system.",
          "Inventory and order tracking in real-time.",
          "Integrated payment gateway for seamless transactions.",
          "Admin dashboard with sales reports and analytics.",
          "User-friendly UI for staff and customers.",
        ],
        service: "Full Stack Development",
      },

      {
        name: "E-Commerce Website",
        overview:
          "A fully functional e-commerce website built with Laravel and Vue.js, featuring product management, cart functionality, and secure payment integration.",
        image: [
          {
            src: "/assets/images/portfolio/ecom2.png",
            alt: "E-Commerce Website",
          },
          {
            src: "/assets/images/portfolio/ecom1.png",
            alt: "E-Commerce Website",
          },
        ],
        slug: "ecommerce-website",
        tech: ["WordPress", "Elementor", "WooCommerce"],
        intro:
          "A scalable and user-friendly e-commerce platform designed for seamless online shopping experiences.",
        client: "Client Project",
        live_link: "https://pinkdream.store/",
        github_link: "",
        features: [
          "Product listing, filtering, and search functionality.",
          "Shopping cart and checkout system with Stripe integration.",
          "User authentication and order tracking.",
          "Admin dashboard for product and order management.",
          "Responsive design for mobile and desktop users.",
        ],
        service: "Full Stack Development",
      },

      {
        name: "Shoe Showcasing Website",
        overview:
          "This is a website I built to showcase various shoe collections. The platform allows users to browse through different categories, filter products, and view detailed information about each shoe. Built with Laravel and integrated with a MySQL database, this project demonstrates my skills in backend development, clean code, and system design. It is fully responsive and includes features such as product search, user authentication, and a seamless shopping experience..",
        image: [
          {
            src: "/assets/images/portfolio/shoe-admin.png",
            alt: "shoe Project Screenshot",
          },
          {
            src: "/assets/images/portfolio/shoe.png",
            alt: "shoe Project Screenshot",
          },
        ],
        slug: "shoe-showcasing-website",
        tech: ["Laravel", "Livewire", "MySQL"],
        intro:
          "This web application allows users to browse and manage a wide range of shoe products, offering features for both customers and admins. Built with Laravel, Livewire, and Bootstrap, it ensures a dynamic, responsive",
        client: "Personal Project",
        service: "Full Stack Development",
        live_link: "",
        github_link: "",
        features: [
          "Customer Side: User authentication, browse categories, view and filter products, color selection, adjust quantity, add to cart/wishlist, checkout, order notifications, order history, manage user profile.",
          "Admin Side: Category, product, brand, and color management, slider management, site settings, user management, order management, and dashboard statistics.",
        ],
      },
      {
        name: "Website For Finding And Reviewing Local Mechanics In Your Area",
        overview:
          "This project focuses on the design and implementation of a website that enables users to find and review local mechanics. The platform allows users to register, search for mechanics based on specific criteria like location and service type, and share their feedback through reviews. The website aims to offer a centralized hub for individuals seeking trustworthy, reliable mechanics by leveraging community input.",
        image: [
          {
            src: "/assets/images/portfolio/mechanics.png",
            alt: "shoe Project Screenshot",
          },
          {
            src: "/assets/images/portfolio/mechanic.png",
            alt: "shoe Project Screenshot",
          },
        ],
        slug: "website-for-finding-and-reviewing-local-mechanics-in-your-area",
        tech: ["Laravel", "Livewire", "MySQL"],
        intro: "Mechanic finder in your area",
        service: "Full Stack Development",
        client: "Personal Project",
        live_link: "",
        github_link: "",
        features: [
          "Users can register and log in to access platform features.",
          "A search function allows filtering mechanics by location, service, and rating",
          "Users can submit reviews and ratings based on their experiences with mechanics, helping others make informed decisions.",
        ],
      },
    ],
  }),
  mutations: {
    setProject(state, project) {
      state.project = project;
    },
  },
  actions: {
    getProject(context, slug) {
      const project = context.state.projects.find(
        (project) => project.slug === slug
      );
      context.commit("setProject", project);
    },
  },
};

export default portfolio;
